// extracted by mini-css-extract-plugin
export default {"root":"ThemeSwitch_root__G+O46"};